import React from 'react'

import { ZariContext } from '_zari/context'
import { Modal, Button } from '_zari/core'

import { IdGen } from 'utils'

import * as RequerimientoService from 'services/requerimiento.service'

import * as Tables from './tables'

const RequerimientosxSocioModal = ({ show, handleClose, dispatch, onFilled }) => {
  const __zariContext = React.useContext(ZariContext)

  const [_keyTabla, setKeyTabla] = React.useState(IdGen.newId())
  const [detalles, setDetalles] = React.useState([])
  const [idsMarcados, setIdsMarcados] = React.useState([])

  const onChangeCheckbox = React.useCallback(id => {
    setIdsMarcados(prev => {
      let salida = [...prev]

      if (salida.some(x => x === id)) {
        salida = salida.filter(x => x !== id)
      } else {
        salida.push(id)
      }

      return salida
    })
  }, [])

  const clickProcesar = React.useCallback(() => {
    __zariContext.loader.open('Procesando requerimientos seleccionados.')

    if (!idsMarcados || idsMarcados.length === 0) {
      __zariContext.snack('warning', 'Seleccionar requerimientos')
      __zariContext.loader.close()
      return
    }

    RequerimientoService.obtenerDetallesxIdsEmpaquetadosAsOrdenCompraInfo(idsMarcados)
      .then(({ data }) => {
        dispatch({
          type: 'fill-requerimientos',
          payload: data
        })
        if (onFilled) onFilled(data)
        __zariContext.toast('info', 'Requerimientos procesados.')
        handleClose()
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, idsMarcados, handleClose, dispatch])

  React.useEffect(() => {
    __zariContext.loader.open('Obteniendo requerimientos aprobados.')

    RequerimientoService.obtenerEmpaquetadosTodosParaOrdenCompra()
      .then(({ data }) => {
        setKeyTabla(IdGen.newId())
        setDetalles(data)
        __zariContext.toast('info', 'Lista de requerimientos actualizada.')
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  return (
    <Modal show={show} size='lg'>
      <Modal.Header>
        <Modal.Title>Requerimientos Aprobados</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tables.DetallesTable
          key={_keyTabla}
          detalles={detalles}
          idsMarcados={idsMarcados}
          onChangeCheckbox={onChangeCheckbox}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button outline tiny color='secondary' onClick={handleClose}>
          Cancelar
        </Button>
        <Button tiny onClick={clickProcesar}>
          Procesar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(RequerimientosxSocioModal)
